module.exports = __webpack_public_path__ + "static/media/learned_rule-01.17ed815d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/learned_rule-01.png
// module id = 518
// module chunks = 0